import React from 'react';
import { ArrowRight, Upload, Globe, Zap, FileText } from 'lucide-react';
import './LandingPage.css';

function LandingPage() {

  function openFile(){
    window.open(`https://pdf-language-translator.onrender.com`)
  }
  return (
    <div className="app">
      <nav className="navbar">
        <div className="logo">
          <FileText className="logo-icon" />
          <span>PDF Translator</span>
        </div>
        <ul className="nav-links">
          <li><a href="#features">Features</a></li>
          <li><a href="#how-it-works">How It Works</a></li>
          <li><a href="#try-it">Try It</a></li>
        </ul>
      </nav>

      <header className="header">
        <h1 className="animate-fade-in">PDF Language Converter</h1>
        <p className="animate-fade-in animate-delay-1">Revolutionize your document translation process with our cutting-edge PDF Language Converter. Break down language barriers and expand your global reach effortlessly!</p>
        <a href="#try-it" className="cta-button animate-fade-in animate-delay-2">
          Try it Now
          <ArrowRight className="icon" />
        </a>
      </header>

      <section id="features" className="features">
        <h2 className="animate-fade-in">Powerful Features</h2>
        <div className="feature-grid">
          <FeatureCard
            icon={<Zap className="feature-icon" />}
            title="Lightning-Fast Translations"
            description="Our advanced AI algorithms deliver rapid translations without compromising accuracy. Get your documents translated in record time!"
            delay={0}
          />
          <FeatureCard
            icon={<Upload className="feature-icon" />}
            title="User-Friendly Interface"
            description="With our intuitive design, translating PDFs is as easy as 1-2-3. No technical expertise required – just upload, select, and convert!"
            delay={1}
          />
          <FeatureCard
            icon={<Globe className="feature-icon" />}
            title="Multilingual Support"
            description="Translate your PDFs to and from over 100 languages. Whether it's Spanish, Mandarin, Arabic, or beyond, we've got you covered."
            delay={2}
          />
        </div>
      </section>

      <section id="how-it-works" className="how-it-works">
        <h2 className="animate-fade-in">How It Works</h2>
        <ol className="steps">
          <Step number={1} text="Upload your PDF document to our secure platform." delay={0} />
          <Step number={2} text="Choose your target language from our extensive list." delay={1} />
          <Step number={3} text="Click 'Convert' and receive your professionally translated PDF in minutes!" delay={2} />
        </ol>
      </section>

      <section id="try-it" className="cta-section">
        <h2 className="animate-fade-in">Ready to Break Language Barriers?</h2>
        <p className="animate-fade-in animate-delay-1">Join thousands of satisfied users who have transformed their communication with our PDF Language Converter. Try it now and experience the difference!</p>
        <button className="cta-button animate-fade-in animate-delay-2"
        onClick={()=>{openFile()}}>Get Started For Free</button>
      </section>

      <footer className="footer">
        <p>&copy; 2024 PDF Language Converter. All rights reserved.</p>
        <p>Empowering global communication, one document at a time.</p>
      </footer>
    </div>
  );
}

function FeatureCard({ icon, title, description, delay }) {
  return (
    <div className={`feature-card animate-fade-in animate-delay-${delay}`}>
      <div className="feature-icon-wrapper">{icon}</div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
}

function Step({ number, text, delay }) {
  return (
    <li className={`step animate-fade-in animate-delay-${delay}`}>
      <div className="step-number">{number}</div>
      <p>{text}</p>
    </li>
  );
}

export default LandingPage;